import styled from 'styled-components';
import Image from '@klv/atoms/image';
import Typography from '@klv/atoms/typography';
import Buttons from '@klv/molecules/buttons';
import Grid from '@klv/utils/grid';

import type { TColorVariant } from '@klv/shared/styles/types';
import type { ICtaStatementDisclaimer } from '../types';

export const CtaStatementGrid = styled(Grid)`
  align-items: center;
`;

export const ContentContainer = styled.div<{ $removeOverlapGrid: boolean; }>`
  grid-area: 3 / 1 / 3 / 9;
  position: relative;
  z-index: 1;

  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    ${({ $removeOverlapGrid }) => ($removeOverlapGrid ? 'grid-area: 1 / 1 / 3 / 6' : 'grid-area: 1 / 1 / 3 / 13')};
  }
`;

export const PrimaryImage = styled(Image)`
  grid-area: 1 / 1/ 3 / -1;
  margin: 0 0 3.2rem 0;

  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    grid-area: 1 / 7 / 3 / 13;
    margin: 0;
  }
`;

export const StyledCtaStatement = styled.div<{ background: TColorVariant; }>`
  background: ${({ background, theme }) => theme.ctaStatement[background].background};
  color: ${({ background, theme }) => theme.ctaStatement[background].text};
  ${({ theme }) => theme.globalPadding};
`;

export const StyledButtons = styled(Buttons)`
  margin: 3.2rem 0 0;

  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
  margin-top: 5.5rem;
  }
`;

export const StyledDisclaimer = styled(Typography)<ICtaStatementDisclaimer>`
  grid-column: 1 / -1;
  margin-top: ${({ $afterButton }) => ($afterButton ? '3.2rem' : '5.5rem')};

  ${({ $hasImage, theme }) => ($hasImage
    ? `${theme.screenSize.s768.mediaQuery} {
        grid-column: 1 / 6;
      }`
    : ''
  )}
`;

export const StyledHeadline = styled(Typography)``;
